module.exports = __webpack_public_path__ + "img/IconWomensHealth.cd86fe46.svg";